import { Pipe, PipeTransform } from '@angular/core';
import { toWordsOrdinal } from 'number-to-words';

@Pipe({
    name: 'toWordsOrdinal',
  standalone: false
})
export class ToWordsOrdinalPipe implements PipeTransform {
  transform(value: any) {
    let asNumber = Number(value);
    if (isNaN(asNumber)) {
      return '' + value;
    }

    return toWordsOrdinal(asNumber);
  }
}
